import { useState } from 'react';
import { trackDesignSystemAction } from 'analytics';
import ColorButton from 'components/Widget/Button/ColorButton';
import Lightbox from 'components/Widget/Lightbox';
import type { ShowcaseDesignSystem } from '../index';
import * as S from './styles';

interface ShowcaseCardProps {
	item: ShowcaseDesignSystem;
	onUse: (item: ShowcaseDesignSystem) => void;
}

const ShowcaseCard = ({ item, onUse }: ShowcaseCardProps) => {
	const [lightboxImageUrl, setLightboxImageUrl] = useState<string | null>(null);

	return (
		<S.Base>
			<S.Preview
				onClick={() => item.imageUrl && setLightboxImageUrl(item.hiResImageUrl || item.imageUrl)}
			>
				{item.imageUrl && <S.PreviewImage src={item.imageUrl} alt={item.title} />}
			</S.Preview>
			<Lightbox imageUrl={lightboxImageUrl} onClose={() => setLightboxImageUrl(null)} />
			<S.Body>
				<S.Info>
					<S.Name>{item.title}</S.Name>
					{item.metadata && <S.Metadata>{item.metadata}</S.Metadata>}
					<S.Description>{item.description}</S.Description>
					{item.tags.length > 0 && (
						<S.Tags>
							{item.tags.map((tag) => (
								<S.Tag key={tag}>{tag}</S.Tag>
							))}
						</S.Tags>
					)}
					<S.Links>
						<S.Link
							href={item.dsUrl}
							target="_blank"
							rel="noopener noreferrer"
							onClick={() =>
								trackDesignSystemAction('gallery_view_ds', {
									dsId: item.designSystemId,
									dsName: item.title,
								})
							}
						>
							View DS
						</S.Link>
						{item.projectUrl && (
							<>
								<S.LinkSeparator>·</S.LinkSeparator>
								<S.Link
									href={item.projectUrl}
									target="_blank"
									rel="noopener noreferrer"
									onClick={() =>
										trackDesignSystemAction('gallery_view_project', {
											dsId: item.designSystemId,
											dsName: item.title,
										})
									}
								>
									View Project
								</S.Link>
							</>
						)}
					</S.Links>
				</S.Info>
				<S.ActionArea>
					<ColorButton
						label="Use DS"
						color="blue"
						size="small"
						onClick={() => {
							trackDesignSystemAction('gallery_use_ds', {
								dsId: item.designSystemId,
								dsName: item.title,
							});
							onUse(item);
						}}
					/>
				</S.ActionArea>
			</S.Body>
		</S.Base>
	);
};

export default ShowcaseCard;
